import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class FieldGoalFumbleNoRecovery extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            play.historyContains(FootballState.FieldGoal) &&
            fragment.associatedState === FootballState.FumbleNotRecovered
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        ruleContext.setAwardFirstDown(true);
    }
}
